import styled from "@emotion/styled";
import {
  Grid,
  GridColumn,
  Heading,
  MediaQueries,
  Spacings,
} from "@polestar/component-warehouse-react";

import RelatedNewsArticle from "./RelatedNewsArticle";

import { Section } from "~/common/components";
import { type ParsedImage } from "~/common/types";

const StyledRelatedHeading = styled(Heading)`
  grid-column: span 7;
  margin: 0 0 ${Spacings.xxLarge};

  ${MediaQueries.tablet},
  ${MediaQueries.desktop},
  ${MediaQueries.desktopWide} {
    margin: 0 0 ${Spacings.xxLarge};
  }
`;

const StyledGrid = styled(Grid)`
  grid-row-gap: ${Spacings.xLarge};
`;

const StyledCardWrapper = styled.div`
  ${MediaQueries.desktop} {
    width: auto;
  }
`;

interface Props {
  readonly locale: string;
  readonly title: string;
  readonly articles: Array<{
    id: string;
    slug?: string;
    headline?: string;
    ingress?: string;
    publishDateLocalised: string;
    images: {
      imageDesktop?: ParsedImage;
      imageTablet?: ParsedImage;
      imageMobile?: ParsedImage;
    };
  }>;
  readonly readMoreLabel: string;
}

const RelatedNewsArticles = ({
  locale,
  articles,
  title,
  readMoreLabel,
}: Props) => {
  if (articles.length === 0) {
    return null;
  }

  return (
    <Section>
      <StyledRelatedHeading level={2}>{title}</StyledRelatedHeading>
      <StyledGrid data-test-id="related-news-articles-grid">
        {articles.map(
          ({ id, slug, headline, ingress, publishDateLocalised, images }) => {
            return (
              <GridColumn key={id} span={{ mobile: 4, tablet: 8, desktop: 4 }}>
                <StyledCardWrapper>
                  <RelatedNewsArticle
                    locale={locale}
                    slug={slug}
                    headline={headline}
                    ingress={ingress}
                    date={publishDateLocalised}
                    readMoreLabel={readMoreLabel}
                    imageMobile={images.imageMobile}
                    imageTablet={images.imageTablet}
                    imageDesktop={images.imageDesktop}
                  />
                </StyledCardWrapper>
              </GridColumn>
            );
          }
        )}
      </StyledGrid>
    </Section>
  );
};

export default RelatedNewsArticles;
